<div class="relative flex max-h-[90vh] w-full flex-1 flex-col overflow-hidden rounded-3xl bg-background-white p-12">
  <h2 class="typo-h2 mb-10 text-center font-semibold text-text-primary">
    {{ 'express_app_baa_modal_title' | translate }}
  </h2>
  <button (click)="onCloseDialog()" class="absolute right-[52px] top-[52px]">
    <svg-icon size="sm" key="px-16-x" class="text-text-primary"></svg-icon>
  </button>

  @switch (modalStore.step()) {
    @case (BaaSignModalStep.AuthorizedAgreement) {
      <lib-baa-sign-form class="flex min-h-0 flex-1 flex-col"></lib-baa-sign-form>
    }
    @case (BaaSignModalStep.AuthorizedSuccess) {
      <lib-baa-sign-success (returnToNotes)="onReturnToNotes()" class="flex min-h-0 flex-1 flex-col"></lib-baa-sign-success>
    }
    @case (BaaSignModalStep.NotAuthorizedSignerDetails) {
      <lib-baa-authorized-signer-details class="flex min-h-0 flex-1 flex-col"></lib-baa-authorized-signer-details>
    }
    @case (BaaSignModalStep.NotAuthorizedSuccess) {
      <lib-baa-request-sent-success
        [signerFullName]="modalStore.signerFullName()"
        [signerEmail]="modalStore.signerEmail()"
        (done)="onReturnToNotes()"
        class="flex min-h-0 flex-1 flex-col"
      ></lib-baa-request-sent-success>
    }
  }
</div>
